import { isNullish } from '@adornis/assert/isNullish.js';
import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import { GermanInsuranceTypes } from '../../../db/enums/misc-enums.js';
import type { Person } from '../../../users/entities/person.js';

@Entity()
export class AGSozialVersicherung extends AdornisEntity {
  static override _class = 'AGSozialVersicherung';

  @Field(type => String)
  kvAGZuschuss?: string;

  @Field(type => String)
  pvAGZuschuss?: string;

  @Field(type => String)
  pvGesamtbeitrag?: string;

  @Field(type => String)
  beschaeftigungsart?: string;

  @Field(type => Boolean, { default: v => v ?? false })
  altfallGleiter!: boolean;

  @Field(type => String)
  rentner?: string;

  @Field(type => Int)
  beitragsgruppenschluesselKV: Maybe<number>;

  @Field(type => Int)
  beitragsgruppenschluesselRV: Maybe<number>;

  @Field(type => Int)
  beitragsgruppenschluesselAV: Maybe<number>;

  @Field(type => Int)
  beitragsgruppenschluesselPV: Maybe<number>;

  @Field(type => Boolean, { default: v => v ?? false })
  applyMidijob: Maybe<boolean>;

  @Field(type => String)
  privatVersichert?: string;

  @Field(type => Boolean, { default: v => v ?? false })
  krankentagegeld!: boolean;

  @Field(type => String)
  mehrfachbeschaeftigung?: string;

  @Field(type => Boolean, { default: v => v ?? false })
  leiharbeitsverhaeltnis!: boolean;

  @Field(type => String)
  ergaenzungSV?: string;

  @Field(type => String)
  geringfuegigeBeschaeftigung?: string;
}

if (A.isClient) {
  AGSozialVersicherung.prototype.validator = new Validator({
    beitragsgruppenschluesselKV: options => {
      if (options.simpleValidation) return;
      if (isNullish(options.value)) return nonOptional({ allowFalsy: true })(options);

      if (
        options.value === 9 &&
        (options.personOfContract as Person).mitarbeiterDaten?.anSozialVersicherung?.versicherungsStatus !==
          GermanInsuranceTypes.VOLUNTARY
      ) {
        throw new ValidationError(
          'Der Beitragsgruppenschlüssel KV darf nur bei freiwillig Versicherten auf 9 gesetzt werden.',
        );
      }

      if (
        (options.personOfContract as Person).mitarbeiterDaten?.anSozialVersicherung?.versicherungsStatus ===
          GermanInsuranceTypes.VOLUNTARY &&
        options.value === 9 &&
        options.value === 0
      ) {
        throw new ValidationError(
          'Der Beitragsgruppenschlüssel KV darf nur bei freiwillig Versicherten auf 9 gesetzt werden.',
        );
      }
    },
    beitragsgruppenschluesselRV: options =>
      options.simpleValidation ? (() => {})() : nonOptional({ allowFalsy: true })(options),
    beitragsgruppenschluesselAV: options =>
      options.simpleValidation ? (() => {})() : nonOptional({ allowFalsy: true })(options),
    beitragsgruppenschluesselPV: options =>
      options.simpleValidation ? (() => {})() : nonOptional({ allowFalsy: true })(options),
  });
}
